import Icon from '@/components/snippets/icon/icon'
import { FilterItem } from 'libs/searchspring/components/collection/filters/FilterItem'
import { FilterSelected } from 'libs/searchspring/components/collection/filters/FilterSelected'
import { calculateProductCount } from 'libs/searchspring/components/collection/filters/ProductCount'
import { useFilters } from 'libs/searchspring/hooks/useFilters'
import { useInfiniteScrollResults } from 'libs/searchspring/hooks/useInfiniteScrollResults'
import { useEffect, useRef } from 'preact/hooks'
import { scrollHistoryManager } from 'helpers/scroll-history'

export function FilterDrawer({ id = 'filters', showFilters = false }) {
  const {
    handleClearFilters,
    handleToggleFilter,
    handleRemoveFilter,
    activeFilters,
    fetchedFilters
  } = useFilters()

  const { results, isLoading } = useInfiniteScrollResults()
  const totalResults = calculateProductCount(results)
  const initialLoadDone = useRef(false)
  const isDesktop = useRef(window.innerWidth >= 1024)
  const isSearch = scrollHistoryManager.getPageType() === 'search'

  useEffect(() => {
    if (showFilters && isDesktop.current && !initialLoadDone.current) {
      if (isSearch) {
        setTimeout(() => {
          document.querySelector('#toggle-filters')?.click()
          initialLoadDone.current = true
        }, 100)
      } else if (!isLoading && results) {
        document.querySelector('#toggle-filters')?.click()
        initialLoadDone.current = true
      }
    }
  }, [isLoading, results, showFilters, isSearch])

  return (
    <x-modal
      className="group/filters z-60"
      data-id={id}
    >
      <div className="flex flex-col fixed top-0 left-0 w-full h-view pointer-events-none group-data-visible/filters:pointer-events-auto z-60 transition-all">
        <div
          className="flex flex-col size-full max-w-[338px] lg:max-w-[447px] bg-secondary -translate-x-full-margin group-data-visible/filters:translate-x-0 z-2 transition-all"
        >
          <div class="shrink-0 flex flex-col">
            <div className="flex gap-x-gutter items-center justify-between w-full h-[60px] px-margin lg:px-1.5 border-b border-neutral-light">
              <h2 className="h6 font-medium">Apply Filters</h2>
              <button
                className="size-[13px] children:size-full"
                data-modal-parent={id}
                data-modal-role="close"
                aria-label="Close Filters"
              >
                <Icon id="close" />
              </button>
            </div>
            <FilterSelected activeFilters={activeFilters} onRemove={handleRemoveFilter} onClear={handleClearFilters} />
          </div>
          <div className="grow flex flex-col overflow-y-scroll no-scrollbar overscroll-none">
            {fetchedFilters.length > 0 ? (
              fetchedFilters.map((filter) => (
                <FilterItem
                  filter={filter}
                  onFilter={handleToggleFilter}
                  fetchedFilters={fetchedFilters}
                  activeFilters={activeFilters}
                  key={filter.field}
                />
              ))
            ) : (
              <p className="px-margin lg:px-1.5 py-1 text-neutral-secondary">No filters available</p>
            )}
          </div>
          <div className="shrink-0 flex gap-x-gutter w-full px-margin lg:px-1.5 py-1.5 border-t border-neutral-light">
            {activeFilters.size > 0 && (
              <button
              className="btn btn-primary btn-border btn-m"
              onClick={handleClearFilters}
              aria-label="Clear Filters"
            >
              Clear All
            </button>
            )}
            <button
              className="grow btn btn-primary btn-fill btn-m"
              data-modal-parent={id}
              data-modal-role="close"
              aria-label="View Results"
            >
              View {totalResults} Results
            </button>
          </div>
        </div>
        <button
            class="fixed inset-tl size-full bg-neutral-black/60 opacity-0 group-data-visible/filters:opacity-100 pointer-events-none group-data-visible/filters:pointer-events-auto cursor-w-resize transition-all"
            data-modal-parent={id}
            data-modal-role="close"
            aria-label="Close Filters"
          >
          </button>
      </div>
    </x-modal>
  )
}
